import React, { useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { safeURIDecode } from "../../utils";
import isEmail from "validator/lib/isEmail";
import { Button, Snackbar, Alert, CircularProgress } from "@mui/material";
import ClockIcon from "../../Assets/Images/Clock.svg";
import CircleIcon from "../../Assets/Images/Question.svg";
import LightbulbIcon from "../../Assets/Images/bulb.svg";
import SlidersIcon from "../../Assets/Images/ArrowArcRight.svg";
// import PercentIcon from "../../Assets/Images/circle-percent.svg";
// import TrendingUpIcon from "../../Assets/Images/redo-dot.svg";
import VideoIcon from "../../Assets/Images/video.svg";
import EmailIcon from "../../Assets/Images/mail.svg";
import "./HowItWorks.scss";

const HowItWorks = () => {
  
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const { id } = useParams();
  const assessmentPageId = 1052;

  const nextPage = () => {
    navigate(`/assessment/${id}/${assessmentPageId}?${searchParams}`, { replace: true });
  }

  return (
    <div className="how-wrapper flex-container">
      <div className="top">
        <h2 className="how-title">How It Works</h2>
        <hr className="how-divider" />
        <div className="how-card">
          <ul className="how-list">
            <li>
              <img src={ClockIcon} className="icon" alt="icon" />
              <div className="point-text">3-minute evaluation</div>
            </li>
            <li>
              <img src={CircleIcon} className="icon" alt="icon" />
              <div className="point-text">4 multiple-choice questions</div>
            </li>
            <li>
              <img src={LightbulbIcon} className="icon" alt="icon" />
              <div className="point-text">Context for each question</div>
            </li>
            <li>
              <img src={SlidersIcon} className="icon" alt="icon" />
              <div className="point-text">3 actionable next steps</div>
            </li>
            <li>
              <img src={VideoIcon} className="icon" alt="icon" style={{ alignSelf: "flex-start", marginTop: "1px" }} />
              <div className="point-text">Optional free 30-minute virtual call to better understand your&nbsp;results</div>
            </li>
            <li>
              <img src={EmailIcon} className="icon" alt="icon" style={{ alignSelf: "flex-start", marginTop: "1px" }} />
              <div className="point-text">Email copy of your results along with 5 insights about high-capacity&nbsp;givers</div>
            </li>
          </ul>
        </div>
      </div>

      <div className="mid"></div>
      <div className="bottom">
        <Button className="how-btn" onClick={nextPage}>Head to Q1</Button>
      </div>
    </div>
  );
};

export default HowItWorks;
